import * as React from "react";
import { useTheme, Typography, Stack, Box, useMediaQuery } from "@mui/material";
import space_time from "../images/space_time.png";
import { Architecture, Dns, School } from "@mui/icons-material";
import { Link as ScrollLink } from "react-scroll";

const SideMenu = ({}) => {
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down(1000));

  const menuItemStyle = {
    text: {
      transition: "all .3s",
      textAlign: "center",
      color: theme.palette.primary.main,
      fontSize: smallScreen ? "12px" : "12px",
      fontWeight: theme.typography.fontWeightLight,
      m: 0,
      p: 0,
      "&:hover": {
        transition: "all .3s",
        color: theme.palette.common.black,
      },
      whiteSpace: "nowrap",
    },
    icon: {
      color: theme.palette.primary.main,
      fontSize: smallScreen ? "14px" : "26px",
      mr: ".3rem",
    },
    container: {
      px: smallScreen ? ".3rem" : ".5rem",
      alignItems: "center",
      justifyContent: "center",
      py: smallScreen ? "0.2rem" : "0.5rem",
      borderRadius: "50px",
      transition: "al .3ls",
      "&:hover": {
        transition: "al .3ls",
        cursor: "pointer",
        boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 8%)",
      },
    },
  };

  const menuItemsList = [
    {
      title: "Mastered Technologies",
      to: "master-techs",
    },
    {
      title: "Sectors I worked in",
      to: "sectors",
    },
    {
      title: "What I studied till now",
      to: "studies",
    },
  ];

  return (
    <Stack
      sx={{
        alignItems: "center",
        pb: "2rem",
        height: "100%",
        overflow: "auto",
      }}
    >
      <Stack
        sx={{
          height: "30vh",
          mb: "2.5rem",
          bgcolor: theme.palette.common.black,
          width: "100%",
        }}
      >
        {/* <Typography
          sx={{
            fontFamily: "'Oswald', sans-serif",
            fontWeight: 600,
            fontSize: "18px",
            color: theme.palette.common.white,
            my: "1rem",
            textAlign: "center",
          }}
        >
          CRIS CIRHUZA
        </Typography>
        <Stack
          sx={{
            width: smallScreen ? "95%" : "70%",
            alignItems: "center",
            justifyContent: "center",
            mb: "2rem",
          }}
        >
          <img
            src={space_time}
            alt="space-time"
            style={{
              width: "70%",
            }}
          />
        </Stack> */}
      </Stack>
      <Stack
        spacing={"0.8rem"}
        sx={{
          alignItems: "center",
        }}
      >
        {menuItemsList?.map((target) => {
          return (
            <ScrollLink
              activeClass="active"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
              to={target?.to}
            >
              <Stack direction={"row"} sx={menuItemStyle?.container}>
                <School sx={menuItemStyle?.icon} />
                <Typography sx={menuItemStyle?.text}>
                  {target?.title}
                </Typography>
              </Stack>
            </ScrollLink>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default SideMenu;
